module.exports = __webpack_public_path__ + "static/img/erweima.36fc09f9.png";